import axios from 'axios';

var config = {
    baseURL:'https://dev-api.web-container.net/api/',
    timeout: 60*1000,
    headers:{
'Content-Type': 'application/json; charset=utf-8',
'X-Requested-With': 'XMLHttpRequest'
    }
};
// ローカル開発環境
if(document.domain === 'localhost'){
  config.baseURL = 'http://localhost:8002/api/';
}
if(document.domain === 'test-mobile-genba.web-container.net'){
  config.baseURL = 'https://test-api.web-container.net/api/';
}
if(document.domain === 'mobile-genba.web-container.net'){
  config.baseURL = 'https://api.web-container.net/api/';
}

const _axios = axios.create(config);
_axios.interceptors.request.use(
    config => {
        config.headers.common['Authorization']  = 'Bearer ' + localStorage.getItem("genba_device_cd");
        console.log(config)
        return config;  
    }
)
Plugin.install = function(app) {
  app.axios = _axios
  window.axios = _axios
  app.config.globalProperties.axios = _axios
  app.config.globalProperties.$axios = _axios
}

export default Plugin